import { HttpClient } from '../../';

const httpClient = new HttpClient();
const apiBaseUrl = window.OPTIMA_API_BASE_URI;
const resourcesPath = '/v1/app/{appId}/resources?language={language}';

const languages = [

    // Values are all-lowercase to match legacy optima applications
    {title: 'Norsk', value: 'nb-no', cssClass: 'flag-no'},
    {title: 'Svenska', value: 'sv-se', cssClass: 'flag-se'},
    {title: 'English', value: 'en-gb', cssClass: 'flag-gb'},
];

function getResources(appId = 0, languageValue) {
    if (!languageValue) languageValue = getSelectedLanguage().value;
    const url =
        apiBaseUrl +
        resourcesPath.replace('{appId}', appId).replace('{language}', languageValue);

    return httpClient.get(url);
}

function getLanguages() {
    return languages;
}

function getSelectedLanguage() {
    const value = getSelectedLanguageValue();
    return languages.find(lang => lang.value === value) || languages[0];
}

function getSelectedLanguageValue() {
    return localStorage.getItem('language');
}

function setSelectedLanguageValue(value) {
    localStorage.setItem('language', value);
}

export default {
    getResources,
    getLanguages,

    getSelectedLanguage,
    getSelectedLanguageValue,
    setSelectedLanguageValue
};
